import * as React from "react";
import { CardType, MarketTemplate } from "../../../../../data";
import { SecondaryHeadingContent } from "../../SecondaryHeadingContent";

export class RenderSubheading extends React.PureComponent<{
    id: string,
    name: string,
    eventsCountLength: number,
    cms: any,
    marketNames: Array<Array<string>>,
    marketTemplates: MarketTemplate[]
    renderedSubheadings: number,
    cardType: CardType
}, {}> {

    render() {
        const shouldExpand = this.props.renderedSubheadings < this.props.cms.ExpandedGroupItems;
        const eventsCount = this.props.cms.ShowLeaguesEventsCount
            ? `(${this.props.eventsCountLength})`
            : "";
        const props = {...this.props, ...{shouldExpand, eventsCount}};

        return <SecondaryHeadingContent
                key={`subheading-content-${this.props.id}`}
                {...props}
            >
                {this.props.children}
            </SecondaryHeadingContent>
    }

}